import { render } from "./CabinetAttributeModal.vue?vue&type=template&id=0f72c055&scoped=true"
import script from "./CabinetAttributeModal.vue?vue&type=script&lang=js"
export * from "./CabinetAttributeModal.vue?vue&type=script&lang=js"

import "./CabinetAttributeModal.vue?vue&type=style&index=0&id=0f72c055&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f72c055"]])

export default __exports__